import { Theme } from "@remo-co/ui-core/src/types";
import { makeStyles } from "@remo-co/ui-core/src/utils/makeStyles";

export const useStyles = makeStyles<Theme>((theme) => ({
  backButton: {
    position: "absolute",
    left: "20px",
    top: "20px",
    borderRadius: "8px",
    alignContent: "center",
    textDecoration: "none",
  },
  backButtonIcon: {
    fill: theme.palette.events.blueSecondary,
    height: "15px",
  },
  title: {
    fontWeight: "normal",
    marginBottom: "1.5rem",
  },
  container: {
    minHeight: "200px",
  },
}));
